import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02e62acc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lock-overlay__icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lock-overlay__content" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Workstation Locked For Verification"),
  /*#__PURE__*/_createElementVNode("p", null, " Whilst we verify your company we have locked the dashboard. As soon as verification is complete you'll receive an email. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LockIcon = _resolveComponent("LockIcon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["lock-overlay lock-w-8", $props.className])
    }, null, 2),
    _createVNode(_component_v_card, { class: "lock-overlay__card md:!tw-w-[80%]" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_LockIcon)
        ]),
        _hoisted_2
      ]),
      _: 1
    })
  ], 64))
}